/*
 * The User Organisation components english translation.
 */
export const USER_ORGANISATION_COMPONENT_EN = {
  orgaManagement: 'Organisation Management',
  manageOrgaUsersAndSettings: 'Manage organization users and settings',
  loadingOrgaData: 'Loading organization data…',
  retry: 'Retry',
  orgaDetails: 'Organisation Details',
  createUser: 'Create User',
  manageBilling: 'Manage subscription',
  cancelSubscription: 'Cancel Subscription',
  userManagement: 'User Management',
  currentUser: 'Current User',
  noUsersFoundInThisOrga: 'No users found in this organisation.',
  OrganizationName: 'Organisation Name',
  Product: 'Product',
  Active: 'Active',
  CustomerID: 'Customer ID',
  organisationId: 'Organisation ID',
  superOrganisation: 'Super Organisation',
  seats: 'Seats',
  tier: 'Tier',
  used: 'Used',
  available: 'Available',
  freeTrialEnd: 'Free trial ends',
  toViewThisPage: 'To view this page you need to be a Premium Customer',
  subscriptionStatus: 'Subscription Status',
  accountType: 'Account Type',
  contractEndDate: 'Contract End Date',
  salesContact: 'Sales Contact',
  supportContact: 'Support Contact',
  enterpriseDetails: 'Enterprise Details',
  seatsOverview: 'Seat Overview',
  assignTier: 'Assign Tier',
  selectTierPlaceholder: 'Select a tier',
  effectiveTierLabel: 'Effective tier after save',
  effectiveTierUsesOrgDefault: 'This user will inherit the organisation default tier.',
  effectiveTierUsesExplicit: 'This user will use this explicit per-user tier override.',
  tierNotSet: 'No tier set',
  noContract: 'No contract information available',
  contactSupport: 'Contact Support',
  userManagementIntro:
    'Manage teammates here. Use Edit to update profile details, tier assignment, or password reset.',
  userManagementEmptyTitle: 'No managed users yet',
  userManagementEmptyDescription:
    'Create your first teammate to start collaboration across your organisation workspace.',
  cancel: 'Cancel',
  createUserDescription: 'Add a new teammate to your organisation.',
  createUserDescriptionManaged: 'Add a new teammate to the selected managed organisation.',
  fullNamePlaceholder: 'Full name',
  emailPlaceholder: 'Email address',
  assignedTierLabel: 'Assigned tier',
  additionalLicenseWarning:
    'There are no free seats for this tier. Creating this user will purchase an additional license.',
  userCreatedSuccessfully: 'User created successfully',
  pleaseTypeInAName: 'Please type in a name.',
  pleaseTypeInAnEmail: 'Please type in an email.',
  nameMustBeAtLeastTwoCharacters: 'Name must be at least 2 characters.',
  nameMustNotBeLongerThanThirtyCharacters: 'Name must not be longer than 30 characters.',
  stepPurchasing: 'Purchasing license…',
  stepSyncing: 'Activating license…',
  stepSyncingHint: 'This may take a few seconds.',
  stepCreating: 'Creating user…',
  createUserPaid: 'Create user (paid)',
  deleteUser: 'Delete user',
  deleteUserConfirmTitle: 'Are you sure you want to delete this user?',
  deleteUserConfirmDescription:
    'This will permanently delete {name} and transfer their resources to an organisation admin. This action cannot be undone.',
  userDeletedSuccessfully: 'User deleted successfully',
  deleteUserFailed: 'Failed to delete user',
  moveUserToOrganisation: 'Move User',
  moveUserDescriptionManaged:
    'Move this user into another child organisation managed by your super organisation.',
  moveUserSelectLabel: 'Target organisation',
  moveUserSelectPlaceholder: 'Choose a target organisation',
  moveUserSubmit: 'Move user',
  moveUserSuccess: 'User moved successfully',
  moveUserFailed: 'Failed to move user',
  moveUserTargetsLoadFailed: 'Failed to load managed organisations',
  moveUserNoTargets: 'No other managed child organisations are available as move targets.',
  noSeatsAvailableForTier: 'No free purchased seats are available for the selected tier.',
  userUpdatedSuccessfully: 'User updated successfully',
  resetPasswordSuccess: 'Reset password for {name}',
  resetPasswordFailed: 'Could not reset password',
  superOrganisationAssignmentTitle: 'Super Organisation Assignment',
  superOrganisationAssignmentDescription:
    'Full admins assign organisations to a parent super organisation. Parent super admins can manage users and seats across assigned organisations, but they cannot edit this organisation’s customizations or create new organisations on its behalf.',
  superOrganisationSelectLabel: 'Parent organisation',
  superOrganisationSelectPlaceholder: 'Select a super organisation',
  superOrganisationNoneAssigned: 'No super organisation assigned.',
  superOrganisationNoneOption: 'No super organisation',
  superOrganisationAssignmentSaved: 'Super organisation assignment saved',
  superOrganisationAssignmentSaveFailed: 'Failed to save super organisation assignment',
  superOrganisationOptionsLoadFailed: 'Failed to load available super organisations',
  managedOrganisationsTitle: 'Managed Organisations',
  managedOrganisationsDescription:
    'Manage user seats for organisations assigned to your super organisation.',
  managedOrganisationsEmptyTitle: 'No assigned organisations yet',
  managedOrganisationsEmptyDescription:
    'A full admin must assign child organisations to your super organisation before they appear here.',
  managedOrganisationSelectTitle: 'Select an assigned organisation',
  managedOrganisationSelectDescription:
    'User management and seat changes below apply only to the selected organisation.',
  managedOrganisationSelectLabel: 'Assigned organisation',
  managedOrganisationSelectPlaceholder: 'Choose an organisation',
  superOrganisationCurrentParentLabel: 'Current parent',
  managedOrganisationsOverviewTitle: 'Organisation overview',
  managedOrganisationsOverviewSeatsUsed: 'seats used'
}
/*
 * The User Organisation components german translation.
 */
export const USER_ORGANISATION_COMPONENT_DE = {
  orgaManagement: 'Organisationsmanagement',
  manageOrgaUsersAndSettings: 'Verwalte Nutzer und Einstellungen deiner Organisation',
  loadingOrgaData: 'Organisationsdaten werden geladen…',
  retry: 'Wiederholen',
  orgaDetails: 'Organisationsdetails',
  createUser: 'Nutzer erstellen',
  manageBilling: 'Abo verwalten',
  cancelSubscription: 'Abonnement kündigen',
  userManagement: 'Nutzerverwaltung',
  currentUser: 'Aktueller Nutzer',
  noUsersFoundInThisOrga: 'Keine Nutzer in dieser Organisation gefunden.',
  OrganizationName: 'Organisationsname',
  Product: 'Produkt',
  Active: 'Aktiv',
  CustomerID: 'Kunden-ID',
  organisationId: 'Organisations-ID',
  superOrganisation: 'Super-Organisation',
  seats: 'Nutzer',
  tier: 'Tarif',
  used: 'Genutzt',
  available: 'Verfügbar',
  freeTrialEnd: 'Kostenloser Testzeitraum endet',
  toViewThisPage: 'Um diese Seite zu sehen, benötigst du einen Premium-Account',
  subscriptionStatus: 'Abonnementstatus',
  accountType: 'Kontotyp',
  contractEndDate: 'Vertragsende',
  salesContact: 'Vertriebskontakt',
  supportContact: 'Supportkontakt',
  enterpriseDetails: 'Enterprise-Details',
  seatsOverview: 'Sitzplatzübersicht',
  assignTier: 'Tarif zuweisen',
  selectTierPlaceholder: 'Tarif auswählen',
  effectiveTierLabel: 'Effektiver Tarif nach dem Speichern',
  effectiveTierUsesOrgDefault: 'Dieser Nutzer übernimmt den Standardtarif der Organisation.',
  effectiveTierUsesExplicit: 'Dieser Nutzer verwendet diese explizite Tarifzuweisung.',
  tierNotSet: 'Kein Tarif gesetzt',
  noContract: 'Keine Vertragsinformationen verfügbar',
  contactSupport: 'Support kontaktieren',
  userManagementIntro:
    'Hier verwaltest du dein Team. Mit Bearbeiten passt du Profil, Tarifzuweisung und Passwort-Reset an.',
  userManagementEmptyTitle: 'Noch keine verwalteten Nutzer',
  userManagementEmptyDescription:
    'Erstelle das erste Teammitglied, um die Zusammenarbeit in deiner Organisation zu starten.',
  cancel: 'Abbrechen',
  createUserDescription: 'Füge ein neues Teammitglied zu deiner Organisation hinzu.',
  createUserDescriptionManaged:
    'Füge ein neues Teammitglied zur ausgewählten verwalteten Organisation hinzu.',
  fullNamePlaceholder: 'Vollständiger Name',
  emailPlaceholder: 'E-Mail-Adresse',
  assignedTierLabel: 'Zugewiesener Tarif',
  additionalLicenseWarning:
    'Für diesen Tarif sind keine freien Plätze vorhanden. Das Erstellen dieses Nutzers kauft eine zusätzliche Lizenz.',
  userCreatedSuccessfully: 'Nutzer erfolgreich erstellt',
  pleaseTypeInAName: 'Bitte gib einen Namen ein.',
  pleaseTypeInAnEmail: 'Bitte gib eine E-Mail-Adresse ein.',
  nameMustBeAtLeastTwoCharacters: 'Der Name muss mindestens 2 Zeichen lang sein.',
  nameMustNotBeLongerThanThirtyCharacters: 'Der Name darf nicht länger als 30 Zeichen sein.',
  stepPurchasing: 'Lizenz wird gekauft…',
  stepSyncing: 'Lizenz wird aktiviert…',
  stepSyncingHint: 'Dies kann einige Sekunden dauern.',
  stepCreating: 'Nutzer wird erstellt…',
  createUserPaid: 'Kostenpflichtig Nutzer erstellen',
  deleteUser: 'Nutzer löschen',
  deleteUserConfirmTitle: 'Möchtest du diesen Nutzer wirklich löschen?',
  deleteUserConfirmDescription:
    '{name} wird dauerhaft gelöscht und alle Ressourcen werden an einen Organisationsadmin übertragen. Diese Aktion kann nicht rückgängig gemacht werden.',
  userDeletedSuccessfully: 'Nutzer erfolgreich gelöscht',
  deleteUserFailed: 'Nutzer konnte nicht gelöscht werden',
  moveUserToOrganisation: 'Nutzer verschieben',
  moveUserDescriptionManaged:
    'Verschiebe diesen Nutzer in eine andere Kindorganisation deiner Super-Organisation.',
  moveUserSelectLabel: 'Zielorganisation',
  moveUserSelectPlaceholder: 'Zielorganisation auswählen',
  moveUserSubmit: 'Nutzer verschieben',
  moveUserSuccess: 'Nutzer erfolgreich verschoben',
  moveUserFailed: 'Nutzer konnte nicht verschoben werden',
  moveUserTargetsLoadFailed: 'Verwaltete Organisationen konnten nicht geladen werden',
  moveUserNoTargets: 'Es sind keine anderen verwalteten Kindorganisationen als Ziel verfügbar.',
  noSeatsAvailableForTier: 'Für den gewählten Tarif sind keine freien Plätze vorhanden.',
  userUpdatedSuccessfully: 'Nutzer erfolgreich aktualisiert',
  resetPasswordSuccess: 'Passwort für {name} zurückgesetzt',
  resetPasswordFailed: 'Passwort konnte nicht zurückgesetzt werden',
  superOrganisationAssignmentTitle: 'Super-Organisationszuweisung',
  superOrganisationAssignmentDescription:
    'Volladmins ordnen Organisationen einer übergeordneten Super-Organisation zu. Deren Super-Admins können Nutzer und Plätze über zugewiesene Organisationen hinweg verwalten, aber weder die Customizations dieser Organisation bearbeiten noch in ihrem Namen neue Organisationen anlegen.',
  superOrganisationSelectLabel: 'Übergeordnete Organisation',
  superOrganisationSelectPlaceholder: 'Super-Organisation auswählen',
  superOrganisationNoneAssigned: 'Keine Super-Organisation zugewiesen.',
  superOrganisationNoneOption: 'Keine Super-Organisation',
  superOrganisationAssignmentSaved: 'Super-Organisationszuweisung gespeichert',
  superOrganisationAssignmentSaveFailed:
    'Super-Organisationszuweisung konnte nicht gespeichert werden',
  superOrganisationOptionsLoadFailed:
    'Verfügbare Super-Organisationen konnten nicht geladen werden',
  managedOrganisationsTitle: 'Verwaltete Organisationen',
  managedOrganisationsDescription:
    'Verwalte Nutzerplätze für Organisationen, die deiner Super-Organisation zugeordnet sind.',
  managedOrganisationsEmptyTitle: 'Noch keine zugewiesenen Organisationen',
  managedOrganisationsEmptyDescription:
    'Ein Volladmin muss Kindorganisationen deiner Super-Organisation zuordnen, bevor sie hier erscheinen.',
  managedOrganisationSelectTitle: 'Zugewiesene Organisation auswählen',
  managedOrganisationSelectDescription:
    'Nutzerverwaltung und Platzänderungen unten gelten nur für die ausgewählte Organisation.',
  managedOrganisationSelectLabel: 'Zugewiesene Organisation',
  managedOrganisationSelectPlaceholder: 'Organisation auswählen',
  superOrganisationCurrentParentLabel: 'Aktuelle übergeordnete Organisation',
  managedOrganisationsOverviewTitle: 'Organisationsübersicht',
  managedOrganisationsOverviewSeatsUsed: 'Plätze genutzt'
}
